
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@mui/material/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
//import TableCell from '@material-ui/core/TableCell';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";
//import TableRow from '@material-ui/core/TableRow';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import clsx from "clsx";
import Paper from '@material-ui/core/Paper';
import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';
import { styled } from '@material-ui/core/styles';
const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {
        position: 'relative',
        left: '45%',
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        float: "center",
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    center: {
        position: 'relative',
        left: '49%',
        color: '#ff4717 !important',
    }, center1: {
        position: 'relative',
        left: '47%',
        color: '#ff4717 !important',
        fontWeight: "bold",
    }
    , resultcenter: {
        position: 'relative',
        left: '41%',
        color: '#ff4717 !important',
    },
    textstyles: {
        color: '#ff4717'
    },
    bold: {
        color: '#ff4717 !important',
        position: "relative",
        fontSize: "50px",
        top: "11px",
    }
}));

function CIICalculator() {
    const classes = useStyles();
    /**For CII Calculator ..one : left side , ..two : right side*/
    const [CIICalculator, setCIICalculator] = useState({
        AnnualFualConsumptionOne: "", AnnualDistanceTravelledOne: "", CapacityOne: "", CO2FactorOne: "", resultOne: "",
        AnnualFualConsumptionTwo: "", AnnualDistanceTravelledTwo: "", CapacityTwo: "", CO2FactorTwo: "", resultTwo: "", finalResult: ""
    });
    {/** ciiRatingfeetOverViewTable */ }
    const [CIIRatingFeetOverViewTableData, setCIIRatingFeetOverViewTableData] = useState([{}]);
    const accessInputTagValues = (feildName, value) => {
        debugger
        if (feildName.length > 0) {
            if (value.length > 0) {
                // var regex = /^[0-9]+$/;
                // if (regex.test(value)) {
                //     if (feildName === "AnnualFualConsumptionOne") { setCIICalculator({ ...CIICalculator, AnnualFualConsumptionOne: value }); }
                //     else if (feildName === "AnnualFualConsumptionTwo") { setCIICalculator({ ...CIICalculator, AnnualFualConsumptionTwo: value }); }
                //     else if (feildName === "AnnualDistanceTravelledOne") { setCIICalculator({ ...CIICalculator, AnnualDistanceTravelledOne: value }); }
                //     else if (feildName === "AnnualDistanceTravelledTwo") { setCIICalculator({ ...CIICalculator, AnnualDistanceTravelledTwo: value }); }
                //     else if (feildName === "CapacityOne") { setCIICalculator({ ...CIICalculator, CapacityOne: value }); }
                //     else if (feildName === "CapacityTwo") { setCIICalculator({ ...CIICalculator, CapacityTwo: value }); }
                //     else if (feildName === "CO2FactorOne") { setCIICalculator({ ...CIICalculator, CO2FactorOne: value }); }
                //     else if (feildName === "CO2FactorTwo") { setCIICalculator({ ...CIICalculator, CO2FactorTwo: value }); }
                // } else {
                    // toast.error('Please enter valid number', {
                    //     position: "top-center",
                    //     autoClose: 1000,
                    //     hideProgressBar: false,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     progress: undefined,
                    // });
             //   }
             if (feildName === "AnnualFualConsumptionOne") { setCIICalculator({ ...CIICalculator, AnnualFualConsumptionOne: value }); }
             else if (feildName === "AnnualFualConsumptionTwo") { setCIICalculator({ ...CIICalculator, AnnualFualConsumptionTwo: value }); }
             else if (feildName === "AnnualDistanceTravelledOne") { setCIICalculator({ ...CIICalculator, AnnualDistanceTravelledOne: value }); }
             else if (feildName === "AnnualDistanceTravelledTwo") { setCIICalculator({ ...CIICalculator, AnnualDistanceTravelledTwo: value }); }
             else if (feildName === "CapacityOne") { setCIICalculator({ ...CIICalculator, CapacityOne: value }); }
             else if (feildName === "CapacityTwo") { setCIICalculator({ ...CIICalculator, CapacityTwo: value }); }
             else if (feildName === "CO2FactorOne") { setCIICalculator({ ...CIICalculator, CO2FactorOne: value }); }
             else if (feildName === "CO2FactorTwo") { setCIICalculator({ ...CIICalculator, CO2FactorTwo: value }); }
            } else {
                if (feildName === "AnnualFualConsumptionOne") { setCIICalculator({ ...CIICalculator, AnnualFualConsumptionOne: value }); }
                else if (feildName === "AnnualFualConsumptionTwo") { setCIICalculator({ ...CIICalculator, AnnualFualConsumptionTwo: value }); }
                else if (feildName === "AnnualDistanceTravelledOne") { setCIICalculator({ ...CIICalculator, AnnualDistanceTravelledOne: value }); }
                else if (feildName === "AnnualDistanceTravelledTwo") { setCIICalculator({ ...CIICalculator, AnnualDistanceTravelledTwo: value }); }
                else if (feildName === "CapacityOne") { setCIICalculator({ ...CIICalculator, CapacityOne: value }); }
                else if (feildName === "CapacityTwo") { setCIICalculator({ ...CIICalculator, CapacityTwo: value }); }
                else if (feildName === "CO2FactorOne") { setCIICalculator({ ...CIICalculator, CO2FactorOne: value }); }
                else if (feildName === "CO2FactorTwo") { setCIICalculator({ ...CIICalculator, CO2FactorTwo: value }); }
            }
        }
    }
    const calculateFinalResultExecuteMethod = () => {
        if (CIICalculator.AnnualFualConsumptionOne !== "" && CIICalculator.AnnualFualConsumptionTwo !== "" &&
            CIICalculator.CO2FactorOne !== "" && CIICalculator.CO2FactorTwo !== "" &&
            CIICalculator.AnnualDistanceTravelledOne !== "" && CIICalculator.AnnualDistanceTravelledTwo !== ""
            && CIICalculator.CapacityOne !== "" && CIICalculator.CapacityTwo !== ""

        ) {
            function round(num) {
                //two decimal out put -> 6.25
                var m = Number((Math.abs(num) * 100).toPrecision(15));
                return Math.round(m) / 100 * Math.sign(num);
            }
            var resOne = round((CIICalculator.AnnualFualConsumptionOne * CIICalculator.CO2FactorOne) / (CIICalculator.AnnualDistanceTravelledOne * CIICalculator.CapacityOne));
            var resTwo = round((CIICalculator.AnnualFualConsumptionTwo * CIICalculator.CO2FactorTwo) / (CIICalculator.AnnualDistanceTravelledTwo * CIICalculator.CapacityTwo));
            var resFinal = round(((resOne / resTwo) * 100)); //6.25
            setCIICalculator({ ...CIICalculator, resultOne: resOne, resultTwo: resTwo, finalResult: resFinal });
        } else {
            toast.error('Fill all Fields', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    return (
        <div className={classes.root}>

            <Accordion className="mainaccord pt20 " expanded={true}>
                <AccordionSummary

                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>Carbon Intensity Indicator (CII)
                    </Typography>
                </AccordionSummary>

                <AccordionDetails open>
                    <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                        <div className={classes.root}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={12} className="padbtm0">
                                    <p className="subtitle">CII Calculator</p>
                                    <p>The CII calculator provided here is based on IMO MEPC 336, 337, 338 and 339.
                                        CII regulation applies to ships of 5,000 gross tonnage and above.
                                        An operational energy efficiency rating will be assigned to each ship for each year from 2023 to 2030.
                                    </p>
                                </Grid>
                            </Grid>
                            <br></br>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={12} className="padbtm0">
                                   
                                    <p className="subtitle">Ships CII Rating - Now</p><br />
                                    <Grid item xs={12} md={12} className={classes.center1}>
                                        <p>
                                            CII RATING : <span className={classes.bold}>B</span>
                                        </p>

                                    </Grid>
                                    <Grid item xs={12} md={12} className={classes.center}>


                                    </Grid>
                                    <Grid container>
                                        <Grid item xs>
                                            <h1 style={{ textAlign: "center", marginBottom: 50 }}>2019</h1>
                                            <Grid container spacing={1}>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}>  <label > Annual Fuel consumption(Tons): </label></Paper>
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}><BootstrapInput value={CIICalculator.AnnualFualConsumptionOne} onChange={(e) => { accessInputTagValues("AnnualFualConsumptionOne", e.target.value); }} />  &nbsp;           &nbsp;

                                                    </Paper>
                                                </Grid>
                                                <Grid item xs={12} md={1}>
                                                    <Paper className={classes.paper}>  <label >X  </label></Paper>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <Paper className={classes.paper}>  <label > CO2 factor: </label></Paper>
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}><BootstrapInput value={CIICalculator.CO2FactorOne} onChange={(e) => { accessInputTagValues("CO2FactorOne", e.target.value); }} />  &nbsp;           &nbsp;

                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                            <hr style={{ backgroundColor: "#808080", height: 4, borderRadius: 5 }}></hr>
                                            <Grid container spacing={1}>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}>  <label >Annual Distance Travelled(Nm):  </label></Paper>
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}><BootstrapInput value={CIICalculator.AnnualDistanceTravelledOne} onChange={(e) => { accessInputTagValues("AnnualDistanceTravelledOne", e.target.value); }} />  &nbsp;           &nbsp;

                                                    </Paper>
                                                </Grid>
                                                <Grid item xs={12} md={1}>
                                                    <Paper className={classes.paper}>  <label >X </label></Paper>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <Paper className={classes.paper}>  <label >Capacity (dwt):</label></Paper>
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}><BootstrapInput value={CIICalculator.CapacityOne} onChange={(e) => { accessInputTagValues("CapacityOne", e.target.value); }} />  &nbsp;           &nbsp;

                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={1} style={{ marginLeft: 200 }}>
                                                <Grid item xs={12} md={12}>

                                                    <Paper className={classes.paper}> <label >Result =</label>  <BootstrapInput disabled className="disabled smallbox1" value={CIICalculator.resultOne} />  &nbsp;           &nbsp;
                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem>

                                        </Divider>
                                        <Grid item xs>
                                            <h1 style={{ textAlign: "center", marginBottom: 50 }}>NOW</h1>
                                            <Grid container spacing={1} style={{ marginLeft: 10 }}>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}>  <label > Annual Fuel consumption(Tons): </label></Paper>
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}><BootstrapInput value={CIICalculator.AnnualFualConsumptionTwo} onChange={(e) => { accessInputTagValues("AnnualFualConsumptionTwo", e.target.value); }} />  &nbsp;           &nbsp;

                                                    </Paper>
                                                </Grid>
                                                <Grid item xs={12} md={1}>
                                                    <Paper className={classes.paper}>  <label >X </label></Paper>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <Paper className={classes.paper}>  <label > CO2 factor: </label></Paper>
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}><BootstrapInput value={CIICalculator.CO2FactorTwo} onChange={(e) => { accessInputTagValues("CO2FactorTwo", e.target.value); }} />  &nbsp;           &nbsp;

                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                            <hr style={{ backgroundColor: "#808080", height: 4, borderRadius: 5 }}></hr>
                                            <Grid container spacing={1} style={{ marginLeft: 10 }}>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}>  <label > Annual Distance Travelled(Nm): </label></Paper>
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}><BootstrapInput value={CIICalculator.AnnualDistanceTravelledTwo} onChange={(e) => { accessInputTagValues("AnnualDistanceTravelledTwo", e.target.value); }} />  &nbsp;           &nbsp;

                                                    </Paper>
                                                </Grid>
                                                <Grid item xs={12} md={1}>
                                                    <Paper className={classes.paper}>  <label >X </label></Paper>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <Paper className={classes.paper}>  <label > Capacity (dwt): </label></Paper>
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <Paper className={classes.paper}><BootstrapInput value={CIICalculator.CapacityTwo} onChange={(e) => { accessInputTagValues("CapacityTwo", e.target.value); }} />  &nbsp;           &nbsp;

                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={1} style={{ marginLeft: 200 }}>
                                                <Grid item xs={12} md={12}>

                                                    <Paper className={classes.paper}> <label >Result =</label>   <BootstrapInput disabled className="disabled smallbox1" value={CIICalculator.resultTwo} />  &nbsp;           &nbsp;
                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12} className={classes.resultcenter}>

                                <Paper className={classes.paper}> <label >Final Result =</label>   <BootstrapInput disabled className="disabled smallbox1" value={CIICalculator.finalResult} />  &nbsp; %          &nbsp;
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Box component="div" className="bunkarinput pt20">
                                    <button type="button" className={classes.btn2} onClick={() => { calculateFinalResultExecuteMethod(); }} >Calculate</button>{''}
                                </Box>

                            </Grid>
                        </div>
                    </FormControl>
                </AccordionDetails>
            </Accordion>
            <Accordion className="mainaccord pt20 " expanded={true}>
                <AccordionSummary aria-controls="panel2a-content" id="panel2a-header">
                    <Typography>CII Rating -Fleet Overview</Typography>
                </AccordionSummary>
                <AccordionDetails open>
                    <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                        <div className={classes.root}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={12} className="padbtm0">
                                    {/** <img src="\assets\images\CIIrating.jpg"></img>
                                   */}
                                    <Box className={classes.root}>
                                        <TableContainer
                                            component={Paper}
                                            className={clsx(classes.TableTheme)}
                                        >
                                            <Table
                                                aria-label="collapsible table"
                                                className={classes.tableLayout}
                                            >
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell className="bl-bg">
                                                            Ship name
                                                        </StyledTableCell>
                                                        <StyledTableCell className="bl-bg">
                                                            IMO No.
                                                        </StyledTableCell>
                                                        <StyledTableCell className="bl-bg">
                                                            Ship type
                                                        </StyledTableCell>
                                                        <StyledTableCell className="bl-bg">
                                                            Dead weight
                                                        </StyledTableCell>
                                                        <StyledTableCell className="bl-bg">
                                                            Gross tonnage
                                                        </StyledTableCell>
                                                        <StyledTableCell className="bl-bg">
                                                            Distance travelled (NM)
                                                        </StyledTableCell>
                                                        <StyledTableCell className="bl-bg">
                                                            Co2 emissions
                                                        </StyledTableCell>                     <StyledTableCell className="bl-bg">
                                                            Attained CII
                                                        </StyledTableCell>
                                                        <StyledTableCell className="bl-bg">
                                                            Required CII
                                                        </StyledTableCell>
                                                        <StyledTableCell className="bl-bg">
                                                            Attained CII/Required CII
                                                        </StyledTableCell>

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <StyledTableCell >
                                                            <Box></Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell >
                                                            <Box></Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell >
                                                            <Box></Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell >
                                                            <Box></Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell >
                                                            <Box> </Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell >
                                                            <Box></Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell >
                                                            <Box></Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell >
                                                            <Box></Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell >
                                                            <Box> </Box>
                                                        </StyledTableCell>
                                                        <StyledTableCell >
                                                            <Box></Box>
                                                        </StyledTableCell>

                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                </Grid>
                            </Grid>
                        </div>
                    </FormControl>
                </AccordionDetails>
            </Accordion>
            {/* <Box component="div">
                <Grid item xs={12} md={12} className="padbtm0">
                    <p className="subtitle">Fuel Type</p>
                </Grid>


            </Box> */}

        </div>
    );
}
export default CIICalculator;